<template>
  <b-container fluid>
    <div class="main-container">
      <div
        v-for="user in users"
        :key="user.id"
        class="container-users mr-5 mb-3"
      >
        <div v-if="user.image === null">
          <img
            src="../../assets/user.png"
            alt="Usuário"
            width="65"
            height="65"
            class="rounded-circle"
          />
        </div>
        <div v-else>
          <img
            :src="user.image"
            alt="Usuário"
            width="65"
            height="65"
            class="rounded-circle"
          />
        </div>
        <div>
          <div>
            <span class="name-user-settings"> {{ user.name }}</span>
          </div>
          <b-icon
            icon="pencil-fill"
            font-scale="0.8"
            class="mr-1"
            style="color: #615f5f"
          ></b-icon>
          <a @click.prevent="editUser(user)" class="button-edit-settings mr-2">
            Editar
          </a>
          <b-icon
            icon="trash-fill"
            font-scale="0.8"
            class="mr-1"
            style="color: #d12c38"
          ></b-icon>
          <a
            @click.prevent="deleteUserModal(user)"
            class="button-remove-settings"
          >
            Excluir
          </a>
        </div>
      </div>
    </div>
    <ModalEditUser ref="modal" />
    <ModalRemoveUser @responseModalRemoveUser="removeUser()" />
  </b-container>
</template>

<script>
import ModalEditUser from './ModalEditUser.vue';
import ModalRemoveUser from './ModalRemoveUser.vue';
import { RemoveUsers } from '../../services/Users';
import showError from '../../utils/showError';

export default {
  components: { ModalEditUser, ModalRemoveUser },
  props: ['users'],
  data() {
    return {
      userSelected: null,
    };
  },
  methods: {
    editUser(user) {
      const userCopy = { ...user };
      this.$refs.modal.user = userCopy;
      this.$bvModal.show('modal-edit-user');
    },
    deleteUserModal(user) {
      this.userSelected = user;
      this.$bvModal.show('modal-remove-user');
    },
    removeUser() {
      RemoveUsers(this.userSelected.id)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.$bvModal.hide('modal-remove-user');
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        })
        .catch(showError);
    },
  },
};
</script>

<style scoped>
.main-container {
  display: flex;
  flex-wrap: wrap;
}

.container-users {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 100px;
}

.name-user-settings,
.button-edit-settings {
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.name-user-settings {
  font-weight: 700;
  font-size: 25px;
  line-height: 30px;

  color: #000000;
}

.button-edit-settings,
.button-remove-settings {
  cursor: pointer;
  font-weight: 300;
  font-size: 15px;
  line-height: 27px;
  text-decoration-line: underline;
  border-radius: 4px;
  border: none;
}

.button-edit-settings {
  background: rgba(0, 0, 0, 0.16);
  color: #615f5f;
}

.button-remove-settings {
  background: rgba(190, 130, 80, 0.16);
  color: #d12c38;
}

.button-edit-settings:focus,
.button-remove-settings {
  outline: none;
}
</style>
